<template>
    <div class="row">
        <div class="col-lg-12 mb-3">
            <b-card :header="uLang('app.overview')" header-tag="h4" class="bg-default-card">

                <div>
                    <div class="pull-left">
                        <div class="p-2">
                            <span>{{ lang('app.rows_per_page_text') }} : </span>
                            <select class="rowsPerPageClass" name="rowsPerPage" id="rowsPerPage" v-model="rowsPerPage">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="45">45</option>
                                <option value="60">60</option>
                                <option value="90">90</option>
                            </select>
                        </div>
                    </div>
                    <div class="pull-right mb-3 d-flex flex-row justify-content-between">
                        <div class="p-2 mx-4" style="margin-top: 4px">
                            {{ lang('app.show_inactive_projects') }}:
                            <toggle-button v-model="showInactiveProjects" color="#5A4587"/>
                        </div>
                        <div class="p-2">
                            <router-link class="btn btn-brand" :to="{ name: 'admin.trajectory_projects.create' }">
                                {{ uLang('app.add_type', { type: lang('app.trajectory_project') }) }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <trajectory-projects-table :show-inactive-projects="showInactiveProjects" :rows-per-page="rowsPerPage" />
            </b-card>
        </div>
    </div>
</template>

<script>
    import TrajectoryProjectsTable from '~/components/tables/admin/projects/trajectory-project/table';

    export default {
        name: 'index',
        components: {
            'trajectory-projects-table': TrajectoryProjectsTable,
        },
        data() {
            return {
                showInactiveProjects: false,
                rowsPerPage: "15",
            }
        },
    }
</script>

<style lang="css" scoped>
.rowsPerPageClass {
    display: inline-block;
    width: 100px;
    padding: 6px;
}
</style>